<template lang="pug">
  DefaultLayout
    ProjectList
</template>

<script>
import DefaultLayout from '@/layouts/Default.vue';
import ProjectList from '@/components/ProjectList.vue';

export default {
  name: 'ProjectsPage',
  components: { DefaultLayout, ProjectList },
};
</script>
